import { render, staticRenderFns } from "./foodEditName.vue?vue&type=template&id=04129835&scoped=true"
import script from "./foodEditName.vue?vue&type=script&lang=js"
export * from "./foodEditName.vue?vue&type=script&lang=js"
import style0 from "./foodEditName.vue?vue&type=style&index=0&id=04129835&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04129835",
  null
  
)

export default component.exports